import React from "react";
import { CircularProgress, Box } from "@mui/material";

interface LoadingAndEmptyStatesProps {
  isLoading: boolean;
  isRefreshing: boolean;
  hasData: boolean;
  children: React.ReactNode;
}

export const LoadingAndEmptyStates = ({
  isLoading,
  isRefreshing,
  hasData,
  children,
}: LoadingAndEmptyStatesProps) => {
  // Show initial loading screen only on first load, not on refresh
  if ((isLoading && !isRefreshing) || (!hasData && isLoading)) {
    return (
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress />
      </Box>
    );
  }
  // Render children when we have data
  return <>{children}</>;
};
